import React from 'react'
import { ProfileDetails } from './cards/ProfileDetails'
import { SignInMethod } from './cards/SignInMethod'
import { EnderecoDetails } from './cards/EnderecoDetails'
import { TwoFactorAuth } from './cards/TwoFactorAuth'

export function Settings() {
  return (
    <>
      <ProfileDetails />
      <EnderecoDetails />
      <SignInMethod />
      <TwoFactorAuth />
    </>
  )
}
